import SelectField from "./Select";
import { currencies } from "country-data";
import { alphaSort } from "../../utils";

export const availCurrencyCodes = currencies.all
  .map(currency => currency.code)
  .sort(alphaSort());

const commonCodes = ["USD", "EUR", "NOK", "INR"];

// const currencyOptions = [
//   {
//     label: "",
//     options: commonCodes.map(code => ({ label: code, value: code }))
//   },
//   {
//     label: "",
//     options: availCurrencyCodes
//       .filter(item => commonCodes.indexOf(item) < 0)
//       .map(code => ({ label: code, value: code }))
//   }
// ];

const ungroupedCurrencyOptions = [
  ...commonCodes.map(code => ({ label: code, value: code })),
  ...availCurrencyCodes
    .filter(item => commonCodes.indexOf(item) < 0)
    .map(code => ({ label: code, value: code }))
];

// const currencyOptions = currencies.all.map(currency => ({
//   label: `${currency.code}`,
//   value: currency.code
// }));

const CurrencySelect = props => (
  <SelectField options={ungroupedCurrencyOptions} {...props} />
);

export default CurrencySelect;
